// extracted by mini-css-extract-plugin
module.exports = {"citgoHeading":"_citgo_citgoHeading__S_P9o"};